var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"border round-05 pa-05"},[_c('div',[_vm._v("Total Billed: "+_vm._s(Math.moneyFormat(_vm.accountBilled)))]),_c('div',[_vm._v("Total Paid: "+_vm._s(Math.moneyFormat(_vm.accountPaid)))]),_c('hr'),_c('div',[_vm._v("Balance: "),_c('b',[_vm._v(_vm._s(Math.moneyFormat(_vm.accountBilled - _vm.accountPaid, 2)))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }